import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useEffect, useState } from "react";
import DeliveryCashService from "../../services/deliverycash/deliverycashservice";
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
import '../cash-collection-report/cash-collection-report.css';

interface HandoverAmountTrace {
  id: number;
  settleDate: string;
  requestSender: number;
  requestSenderName: string;
  requestTo: number;
  requestToName: string;
  amount: number;
  referenceNumber?: string;
  remarks?: string;
  responseDate: string;
  requestDate: string;
}

interface Props {
  visible: boolean;
  onHide: () => void;
  userID: number;
  userName: string;
  startDate: string;
  endDate: string;
}

const HandoverAmountTraceDatatable: React.FC<Props> = ({
  visible,
  onHide,
  userID,
  userName,
  startDate,
  endDate,
}) => {
  const [loading, setLoading] = useState(false);
  const [handoverData, setHandoverData] = useState<HandoverAmountTrace[]>([]);

  useEffect(() => {
    if (!visible) return;

    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await DeliveryCashService.GetHandovercashTrace({
          userID,
          startDate,
          endDate,
        });
        setHandoverData(response || []);
      } catch (error) {
        console.error("Failed to fetch handover amount trace:", error);
        setHandoverData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [visible, userID, startDate, endDate]);

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB");
  };

  return (
    <Dialog
      header={`Handover Amount Details - ${userName}`}
      visible={visible}
      onHide={onHide}
      style={{ width: "70vw", height: "85vh" }}
      modal
      maximizable
      draggable={false}
      resizable={false}
      contentStyle={{ display: 'flex', flexDirection: 'column', flex: 1, overflow: 'hidden', padding: 0 }}
      pt={{
        header: {
          style: {
            background: 'linear-gradient(135deg, #4CAF50, #388e3c)',
            color: 'white',
            borderRadius: '12px 12px 0 0',
            padding: '0.75rem 1.5rem'
          }
        },
        closeButton: { style: { color: 'white' } },
        closeButtonIcon: { style: { color: 'white' } }
      }}
    >
      <SimpleBar style={{ height: '100%' }} autoHide={false} className="report-modal-simplebar">
        <div style={{ padding: '1.5rem' }}>
          <DataTable
            value={handoverData}
            loading={loading}
            paginator
            rows={10}
            rowsPerPageOptions={[5, 10, 20, 50]}
            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
            currentPageReportTemplate="{first} to {last} of {totalRecords}"
          >
            <Column field="requestToName" header="Sent to" />
            <Column field="amount" header="Amount" />
            <Column
              field="requestDate"
              header="Sent Date"
              body={(rowData) => formatDate(rowData.requestDate)}
            />
          </DataTable>
        </div>
      </SimpleBar>
    </Dialog>
  );
};

export default HandoverAmountTraceDatatable;
